import { FormControl } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { text } from '~/modules/@shared/helpers/text';
import dayjs from 'dayjs';
import { CreateInvoiceForm } from '../../helpers/createInvoiceSchema';

export default function InvoiceScheduledDateField() {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreateInvoiceForm>();

  return (
    <Controller
      control={control}
      name="scheduled_date"
      render={({ field: { value, ...field } }) => (
        <FormControl fullWidth>
          <DatePicker
            {...field}
            onChange={(v) => {
              field.onChange(v?.format('YYYY-MM-DD'));
            }}
            value={value ? dayjs(value) : null}
            slotProps={{
              textField: {
                error: !!errors.scheduled_date,
                helperText: text(errors.scheduled_date?.message),
                FormHelperTextProps: { error: true },
                placeholder: 'MM/DD/YYYY',
              },
              inputAdornment: {
                position: 'start',
              },
            }}
          />
        </FormControl>
      )}
    />
  );
}
